import React from 'react';
import { Tooltip, Alert } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()({
    ellipses: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
});
export default function BlockMsg({ message, severity, action, }) {
    const { classes } = useStyles();
    return (React.createElement(Alert, { severity: severity, action: action, classes: { message: classes.ellipses } },
        React.createElement(Tooltip, { title: message },
            React.createElement("div", null, message))));
}
